// Make sure you have this in the theme.liquid file 
// <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css">
// <script src="https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js"></script>
// <script src="{{ 'splide-library.js' | asset_url }}"></script>

// use this part of code for example
/* <splide-slider-component
  data-per-page="2"
  data-mobile-slides="1"
  data-gap="1.2rem"
  data-breakpoints='{"989":{"perPage":2},"749":{"perPage":1}}'
  style="visibility:hidden;"
>
  <div class="js-slider">  <!-- ovo je bitno -->
    <div>Slide A</div>
    <div>Slide B</div>
    <div>Slide C</div>
    <div>Slide D</div>
  </div>
</splide-slider-component> */

(() => {
    if (customElements.get('splide-slider-component') || !window.Splide) return;
  
    class Slider extends HTMLElement {
      constructor() {
        super();
  
        // inicijalne opcije
        this.options = {
          pagination: false,
          perMove: 1,
        };
  
        // dataset -> properties
        this.gap = this.dataset.gap ?? '2.4rem';
        this.perPage = this.dataset.perPage ?? 3;
        this.mobileSlides = this.dataset.mobileSlides ?? 1;
        this.type = this.dataset.type ?? 'slide';
        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = parseInt(this.dataset.interval) || 5000;
        this.pauseOnHover = this.dataset.pauseOnHover === 'true';
        this.pauseOnFocus = this.dataset.pauseOnFocus === 'true';
        this.pauseOnInteraction = this.dataset.pauseOnInteraction === 'true';
        this.rewind = this.dataset.rewind === 'true';
        this.loop = this.dataset.loop === 'true';
  
        // data-breakpoints (JSON string) -> object
        try {
          this.breakpoints = this.dataset.breakpoints
            ? JSON.parse(this.dataset.breakpoints)
            : {
                989: { perPage: Math.max(1, Math.min( this.perPage, 2 )) },
                749: { perPage: parseInt(this.mobileSlides, 10) || 1, gap: '0.8rem' },
              };
        } catch (e) {
          this.breakpoints = {
            989: { perPage: Math.max(1, Math.min( this.perPage, 2 )) },
            749: { perPage: parseInt(this.mobileSlides, 10) || 1, gap: '0.8rem' },
          };
        }
  
        // kompletiraj options
        this.options = {
          ...this.options,
          perPage: parseFloat(this.perPage),
          gap: this.gap,
          type: this.type,
          breakpoints: this.breakpoints,
          autoplay: this.autoplay,
          interval: this.interval,
          pauseOnHover: this.pauseOnHover,
          pauseOnFocus: this.pauseOnFocus,
          pauseOnInteraction: this.pauseOnInteraction,
          rewind: this.rewind,
          loop: this.loop,
        };
        
      }
  
      // perPage
      get perPage() { return this._perPage; }
      set perPage(v) {
        this._perPage = parseFloat(v);
        if (this.options) this.options.perPage = this._perPage;
      }
  
      // gap
      get gap() { return this._gap; }
      set gap(v) {
        this._gap = v;
        if (this.options) this.options.gap = this._gap;
      }
  
      // breakpoints
      get breakpoints() { return this._breakpoints; }
      set breakpoints(v) {
        this._breakpoints = v || {};
        if (this.options) this.options.breakpoints = { ...this._breakpoints };
      }
  
      // mobileSlides
      get mobileSlides() { return this._mobileSlides; }
      set mobileSlides(v) { this._mobileSlides = parseInt(v, 10) || 1; }
  
      // type
      get type() { return this._type; }
      set type(v) {
        this._type = v;
        if (this.options) this.options.type = this._type;
      }

      // autoplay
      get autoplay() { return this._autoplay; }
      set autoplay(v) {
        this._autoplay = v === 'true' || v === true;
        if (this.options) this.options.autoplay = this._autoplay;
      }

      // interval
      get interval() { return this._interval; }
      set interval(v) {
        this._interval = parseInt(v) || 5000;
        if (this.options) this.options.interval = this._interval;
      }

      // pauseOnHover
      get pauseOnHover() { return this._pauseOnHover; }
      set pauseOnHover(v) {
        this._pauseOnHover = v === 'true' || v === true;
        if (this.options) this.options.pauseOnHover = this._pauseOnHover;
      }

      // pauseOnFocus
      get pauseOnFocus() { return this._pauseOnFocus; }
      set pauseOnFocus(v) {
        this._pauseOnFocus = v === 'true' || v === true;
        if (this.options) this.options.pauseOnFocus = this._pauseOnFocus;
      }

      // pauseOnInteraction
      get pauseOnInteraction() { return this._pauseOnInteraction; }
      set pauseOnInteraction(v) {
        this._pauseOnInteraction = v === 'true' || v === true;
        if (this.options) this.options.pauseOnInteraction = this._pauseOnInteraction;
      }

      // rewind
      get rewind() { return this._rewind; }
      set rewind(v) {
        this._rewind = v === 'true' || v === true;
        if (this.options) this.options.rewind = this._rewind;
      }

      // loop
      get loop() { return this._loop; }
      set loop(v) {
        this._loop = v === 'true' || v === true;
        if (this.options) this.options.loop = this._loop;
      }
  
      connectedCallback() {
        this.ensureMarkup();
        this.initSlider();
      }
  
      disconnectedCallback() {
        if (this.slider) {
          this.slider.destroy();
          this.slider = null;
        }
      }
  
      ensureMarkup() {
        // Dozvoli da korisnik ubaci “čiste” slide-ove, a mi ćemo napraviti Splide strukturu
        let root = this.querySelector('.js-slider');
        if (!root) return;
  
        // Ako već postoji .splide__track, ne diraj
        if (root.classList.contains('splide')) return;
  
        const slides = Array.from(root.children);
        root.classList.add('splide');
  
        const track = document.createElement('div');
        track.className = 'splide__track';
  
        const list = document.createElement('ul');
        list.className = 'splide__list';
  
        slides.forEach((el) => {
          const li = document.createElement('li');
          li.className = 'splide__slide';
          li.appendChild(el); // ubaci originalni čvor
          list.appendChild(li);
        });
  
        track.appendChild(list);
        root.appendChild(track);
      }
  
      initSlider() {
        const sliderElement = this.querySelector('.js-slider');
        if (!sliderElement) return;
  
        if (this.slider) this.slider.destroy();
  
        this.slider = new window.Splide(sliderElement, this.options).mount();
        this.style.visibility = 'visible';
      }
    }
  
    customElements.define('splide-slider-component', Slider);
  
    // NEMA više ručne inicijalizacije nad .js-slider!
    // Ako radiš u Theme Editoru, re-init na section load:
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('splide-slider-component').forEach((el) => {
        // Custom element će sam odraditi connectedCallback kad se doda u DOM
        // Ako je već u DOM-u i obnavlja se sadržaj, možemo ga forsirati:
        if (typeof el.ensureMarkup === 'function') el.ensureMarkup();
        if (typeof el.initSlider === 'function') el.initSlider();
      });
    });
  })();
  

